<template>
  <Register />
</template>

<script>
import Register from "../../components/Users/Register";
/** This component handles the sign-up/register page
 *
 */
export default {
  name: "Signup",
  components: { Register },
};
</script>
